module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-visit-data/event-visit-data.component.scss
// module id = ./src/app/routes/event/event-visit-data/event-visit-data.component.scss
// module chunks = 9